import PageHero from "@/components/sections/PageHero";
import Contact from "@/components/sections/Contact";

export default function ContactPage() {
  return (
    <>
      <PageHero
        eyebrow="/ Contact"
        title="Parlons"
        accent="ensemble"
        description="Devis gratuit, conseil personnalisé, prise de rendez-vous : choisissez le canal qui vous convient."
      />
      <Contact />
    </>
  );
}
